var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Area under construction...")]),_c('img',{attrs:{"width":"10%","src":"https://de.rakko.tools/image/loading_rakko.gif"}})])
}]

export { render, staticRenderFns }